<template>
  <div id="app">
    <div class="header">
      <div class="inner">
      <div class="logo">
                <router-link to="/"><img src="./assets/logo.png" /></router-link>
      </div>
      <div class="menu-ico mobile">
          <i class="fas fa-bars" style="cursor:pointer;" @click="showMenu = !showMenu"></i>
      </div>

      <ul id="nav" :class="['nav', showMenu?'show':'']">
        <li><router-link to="/">Studio</router-link></li>
        <!-- <li><router-link to="/services">Services</router-link></li> -->
        <li><router-link to="/artists">Artists</router-link></li>
        <li><router-link to="/rates">Rates</router-link></li>
        <li><router-link to="/contact">Contact</router-link></li>
      </ul>
      </div>
    </div>
    <router-view/>
    <colophon/>
  </div>
</template>

<style lang="scss">

html {
    box-sizing: border-box;
    padding: 0; margin:0;
  }
  *{
    box-sizing: border-box;
  }
  body{
    padding:0;
    margin:0;
    background-color:black;
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
    /* font-family: 'Lora', serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
}
#nav {
  a {
    // font-weight: bold;
    &.router-link-exact-active {
      color: #8ec9ed;
      font-weight: bold;
    }
  }
}
.header{
  height: 90px;
    position: fixed;
    top:0;
    left:0;
    right:0;
    background-color: rgb(34, 18, 33);
    background: linear-gradient(to bottom, rgba(34, 18, 33, 0.9) 80%,rgba(0,0,0,0) 100%);
    z-index: 999;
}
.header .inner {
  
    display:flex;
    justify-content: space-between;
    max-width:1200px;
    margin: 0 auto;

}
  .logo{
    flex: 0 1 350px;
    padding:10px;
    img{
      max-width: 100%;
    }
  }
ul.nav{
    flex: 6 1 auto;
    font-family: 'Source Sans Pro';
    text-transform: uppercase;
    font-weight: 300;

    display: flex;
    
    max-width:600px;
}
ul.nav li{
    list-style: none;
    display: inline;
    flex: 1 1 auto;
    padding:1em;
    
}
ul.nav li a{

    color: rgba(255, 255, 255, 0.685);
    text-decoration: none;
}
ul.nav li a:hover{
    color: rgb(123, 171, 243);
    border-bottom: 1px solid rgb(123, 171, 243);
}
.mobile{
  display: none;
}
h1, h2{
    font-family: 'Source Sans Pro';
    padding-top: 0;
    margin-bottom:0;
    margin-top: 0;
    color: rgb(123, 171, 243);
}
.page{
  padding: 2em;
  min-height: 100vh;
  
  line-height: 1.7em;
  &.light{
    color: black;
    background-image: url('./assets/bgwhite.png');
    h1, h2{
      color: rgb(69, 45, 67);
    }
  }
  &.dark{
    color: white;
    background-image: url('./assets/bgpurple.png');
  }
  &.black{
    color:white;
    background-image: url('./assets/bgblack.png');
  }
}
@media only screen and (max-width: 800px) {
    .mobile{
        display: block;
    }
    .menu-ico{
        padding:1em;
        font-size: x-large;
    }
    ul.nav{
        display: flex;
        flex-direction: column;
        position: fixed;
        top: 75px;
        bottom:0;
        width:0px;
        right:0;
        background-color: rgba(0,0,0,0.9);
        text-align: center;
        margin:0;
        opacity: 0;
        transition: 1s width;
    }
    ul.nav.show{

        opacity: 1;
        width: 300px;
        transition: 1s width;

    }
    button{
      padding:1em;
      background-color:rgb(72, 28, 67);
      border:2px solid rgb(36, 5, 25);
      border-radius: 10px;
      font-size: 90%;
      margin:0.25em;
      color: white;
      &:hover{
        background-color:rgb(106, 58, 100);
        cursor: pointer;
      }
    }
}
</style>

<script>
import Colophon from '@/components/Colophon.vue'
export default {
  components: {Colophon},
  data: function() {
    return{
      showEquipment: false,
      showMenu: false,
      scrolled: false,
      scrollY: 0,
      studio: 0,
    }
  },
  methods: {
        handleScroll () {
          this.scrolled = window.scrollY > 0;
          this.scrollY = window.scrollY;
        }
      },
      created () {
        window.addEventListener('scroll', this.handleScroll);
      },
      destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
      },
      activated(){
        this.showMenu = false;
      },
      watch:{

        // eslint-disable-next-line
        $route (to, from){
          this.showMenu = false;
        }
      } 
    }

</script>
